import React from 'react'
import { Formik } from 'formik'
import { Paper, Typography, FormControl, InputLabel, Input, Button } from '@material-ui/core'
import {Link, NavLink} from 'react-router-dom'
import * as yup from 'yup'
import { useStyles } from './set-password.styles'

type Props = {
  onSendResetPassword: (password: string) => Promise<void>
  hasValidParams: boolean
  isBusy: boolean
}

const SetPasswordView = (props: Props) => {
  const classes = useStyles()
  const { isBusy } = props

  const validateSchema = yup.object().shape({
    password: yup.string().required('Dit veld is verplicht').min(6, 'Het wachtwoord is te kort'),
    passwordRepeat: yup.string().when('password', (password: string) => {
      return yup
        .string()
        .test('compare', 'De wachtwoorden komen niet overeen', (passwordRepeat) => passwordRepeat === password)
    }),
  })

  return (
    <>
      <main className={classes.main}>
        <Paper className={classes.paper}>
          <Link to={{ pathname: `//axs-ict.com` }} target="_blank" >
            <img src="/axs_logo_payoff.png" className={classes.branding} alt="AXS logo" />
          </Link>
          <Typography component="h1" variant="h5">
            Wachtwoord instellen
          </Typography>

          {!props.hasValidParams ? (
            <>
              <label>Deze URL is niet (meer) geldig.</label>
              <NavLink to="/login">Ga naar inloggen</NavLink>
            </>
          ) : (
            <Formik
              initialValues={{ password: '', passwordRepeat: '' }}
              onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(false)
                await props.onSendResetPassword(values.password)
              }}
              validationSchema={validateSchema}
            >
              {({ errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, initialValues, isValid }) => {
                return (
                  <form className={classes.form} onSubmit={handleSubmit}>
                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="password">Wachtwoord</InputLabel>
                      <Input
                        defaultValue={initialValues.password}
                        id="password"
                        type="password"
                        name="password"
                        autoFocus
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div>
                        <label className={classes.errorLabel}>
                          {errors.password && touched.password && errors.password}
                        </label>
                      </div>
                    </FormControl>

                    <FormControl margin="normal" required fullWidth>
                      <InputLabel htmlFor="password">Wachtwoord (nogmaals)</InputLabel>
                      <Input
                        defaultValue={initialValues.password}
                        id="passwordRepeat"
                        type="password"
                        name="passwordRepeat"
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      <div>
                        <label className={classes.errorLabel}>
                          {errors.passwordRepeat && touched.passwordRepeat && errors.passwordRepeat}
                        </label>
                      </div>
                    </FormControl>

                    <Button
                      disabled={isBusy || isSubmitting || !isValid}
                      onClick={(e: React.MouseEvent | React.KeyboardEvent) => {
                        e.preventDefault()
                        handleSubmit()
                      }}
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                    >
                      Versturen
                    </Button>
                    <NavLink to="/login">Ga naar inloggen</NavLink>
                  </form>
                )
              }}
            </Formik>
          )}
        </Paper>
      </main>
    </>
  )
}

export default SetPasswordView
